<article *ngIf="product$ | async as product" class="section-outset-b container topbar-padding-top">
  <app-breadcrumbs [breadcrumbs]="breadcrumbs" class="d-block my-3"></app-breadcrumbs>
  <app-json-ld [json]="breadcrumbScheme"></app-json-ld>

  <div class="row" *ngIf="product">
    <figure
      class="col-md-6 product__figure"
      [class.set--slider]="(product?.images?.length || 0) > 1"
      [class.is--sold-out]="!product?.availableForSale"
    >
      <!--<app-product-image-slider
        *ngIf="(product?.images?.length || 0) > 1"
        [hasLink]="false"
        [product]="product"
        [showPagination]="true"
        [showVariantImages]="true"
        [loaded]="detailLoaded"
        [activeProductImageId]="getInitialActiveProductImageId(product)"
        [activeVariantColor]="selectedOptions['Color'] || initialOptions?.['Color']"
      ></app-product-image-slider>-->

      <!--[loaded]="detailLoaded"-->

      <app-product-image-slider
        *ngIf="product.images || product.media"
        [product]="product"
        [showPagination]="true"
        [hasLink]="false"
        [selectedVariant]="selectedVariant$ | async"
        [showVideos]="true"
        [sizes]="{ md: 6 }"
        [showVariantImages]="true"
      ></app-product-image-slider>

      <!--<img
        *ngIf="product?.images?.length === 1"
        class="product-image product-image-ratio"
        [src]="product?.images?.[0]?.url"
        [alt]="product?.images?.[0]?.altText"
      />

      <img
        *ngIf="product?.images?.length === 0"
        class="product-image product-image-ratio"
        [src]="'product-placeholder-afbeelding' | fromDictionary"
        alt="Placeholder afbeelding"
      />-->
    </figure>

    <main class="col-md-6 my-4 my-mb-0">
      <header class="mb-4">
        <h1 class="mb-2 d-flex gap-3">
          {{ product.title }}

          <!-- <span class="chip-label type-body-sm text-uppercase chip-filled--danger" *ngIf="!product?.availableForSale">
            {{ 'product-tegel-uitverkocht-label' | fromDictionary }}
          </span> -->
        </h1>

        <em class="d-block fw-semi">
          <span *ngIf="product?.productType">{{ product?.productType }}</span>

          <span class="d-inline-block text-primary" *ngIf="getUnit(product)">
            <span class="d-inline-block ms-1" *ngIf="product?.productType">-</span>
            <span class="d-inline-block" [class.ms-1]="product?.productType">{{ getUnit(product, selectedVariant$ | async) }}</span>
          </span>

          <!-- Text with why its not available -->
          <span
            *ngIf="isAvailable$ | async as isAvailable"
            [ngClass]="!(selectedVariant$ | async)?.availableForSale ? 'text-danger' : 'text-muted'"
          >
            <span
              class="d-inline-block mx-1"
              *ngIf="
                isAvailable.code !== 'AVAILABLE' &&
                (selectedVariant$ | async) &&
                (!product.availableForSale || (!(selectedVariant$ | async)?.availableForSale && product.availableForSale))
              "
            >
              -
            </span>

            <span *ngIf="isAvailable.code !== 'AVAILABLE' && (selectedVariant$ | async)" class="d-inline-block text-lowercase">
              <ng-container *ngIf="!product.availableForSale">
                {{ getLabel('product-status-', isAvailable.code, isAvailable.message) }}
              </ng-container>
              <ng-container *ngIf="!(selectedVariant$ | async)?.availableForSale && product.availableForSale">
                {{ 'variant-niet-beschikbaar-tekst' | fromDictionary }}
              </ng-container>
            </span>
          </span>
        </em>

        <div
          *ngIf="(selectedVariant$ | async)?.price || product?.priceRange?.minVariantPrice as minPrice"
          class="h3 mt-2 mb-0 d-inline-block"
        >
          <ng-container
            *ngIf="
              (selectedVariant$ | async)?.compareAtPrice || product?.compareAtPriceRange?.minVariantPrice as comparePrice;
              else elseDiscountBlock
            "
          >
            <div *ngIf="+comparePrice.amount > +minPrice.amount; else elseDiscountBlock" class="d-inline-flex align-items-center">
              <del class="price--old type-body-sm product-detail__price-old">
                {{ comparePrice.amount | currency: comparePrice.currencyCode }}
              </del>
              <strong class="price--new">{{ minPrice?.amount | currency: minPrice.currencyCode }}</strong>
            </div>
          </ng-container>
          <ng-template #elseDiscountBlock>{{ minPrice?.amount | currency: minPrice.currencyCode }}</ng-template>
        </div>
        <!--
        <strong class="h3 mt-2 mb-0 d-inline-block" *ngIf="selectedVariant?.price || product?.priceRange?.minVariantPrice as minPrice">
          <ng-container *ngIf="selectedVariant?.compareAtPrice || product.compareAtPriceRange.minVariantPrice as comparePrice">
            <del *ngIf="comparePrice.amount > minPrice.amount">
              {{ comparePrice.amount | currency: comparePrice.currencyCode }}
            </del>
          </ng-container>
          {{ minPrice?.amount | currency: minPrice.currencyCode }}
        </strong> -->
      </header>

      <div class="mt-4" *ngIf="variantOptionsLeft$ | async as variantOptionsLeft">
        <ng-container *ngIf="productColors$ | async as products">
          <app-product-swatch-list
            *ngIf="products?.length"
            class="d-block mb-4"
            [activeProduct]="product"
            [products]="products"
          ></app-product-swatch-list>
        </ng-container>

        <div class="mb-4" *ngIf="(product?.variants?.length || 0) > 1 && (product?.options?.length || 0) > 0">
          <ng-container *ngFor="let option of product?.options">
            <app-variant-swatch-list
              [option]="option"
              [product]="product"
              [selectedOptionsFromParams]="(routerState$ | async)?.state?.queryParams"
              *ngIf="isColorVariant(option.name)"
            ></app-variant-swatch-list>

            <app-product-variant-options
              *ngIf="!isColorVariant(option.name)"
              [variants]="product.variants || []"
              [option]="option"
              [product]="product"
              [selectedOptionsFromParams]="(routerState$ | async)?.state?.queryParams"
            ></app-product-variant-options>

            <!--<pre>{{ option | json }}</pre>-->
          </ng-container>
        </div>

        <app-product-amount
          class="d-block mb-4"
          [suffix]="getUnit(product) ?? ''"
          [max]="(maxAmount$ | async) ?? 0"
          (getSelectedAmount)="amount = $event"
        ></app-product-amount>

        <footer class="button-group product-detail__actions" *ngIf="isAvailable$ | async as isAvailable">
          <!-- add to cart button -->
          <button
            *ngIf="(soldOut$ | async) === false"
            class="button button--secondary mobile-w-100"
            [disabled]="isAvailable.code !== 'AVAILABLE'"
            (click)="orderVariant()"
            [attr.title]="getLabel('product-status-', isAvailable.code, isAvailable.message)"
          >
            <span>{{ 'product-status-AVAILABLE' | fromDictionary }}</span>

            <app-icon class="anim--spinning ms-2 icon-sm" anchor="icon-loader" *ngIf="cartLoading$ | async"></app-icon>
          </button>

          <!-- Sold out message -->
          <div class="w-100" *ngIf="soldOut$ | async">
            <ng-container *ngIf="(activeStorefront$ | async)?.id === 2">
              <p class="text-danger fs-body-xs text-max-width-xs">
                {{ 'product-detail-uitverkocht-melding' | fromDictionary }}
              </p>

              <button class="button button--secondary" disabled="disabled">
                <app-icon class="icon-sm" anchor="line-icon-mail"></app-icon>
                <span>{{ 'product-detail-uitverkocht-knoptekst' | fromDictionary }}</span>
              </button>
            </ng-container>

            <ng-container *ngIf="(activeStorefront$ | async)?.id !== 2">
              <p class="text-danger fs-body-xs text-max-width-xs">
                {{ 'product-detail-uitverkocht-melding-houdt-me-op-de-hoogte' | fromDictionary }}
              </p>

              <button class="button button--secondary" (click)="notifyMe()" *ngIf="(klaviyoIsSubScribedBackInStock$ | async) !== true">
                <app-icon class="icon-sm" anchor="line-icon-mail"></app-icon>
                <span>{{ 'product-detail-uitverkocht-melding-houdt-me-op-de-hoogte-knoptekst' | fromDictionary }}</span>
              </button>

              <span class="button button--success button-outline button-outline--no-hover" *ngIf="klaviyoIsSubScribedBackInStock$ | async">
                <app-icon class="chip chip--success icon-xs" anchor="icon-check"></app-icon>
                <span>{{ 'product-detail-uitverkocht-melding-houdt-me-op-de-hoogte-gelukt' | fromDictionary }}</span>
              </span>
            </ng-container>
          </div>

          <!-- Download pattern -->
          <ng-container *ngIf="product.metafield">
            <div class="product-pattern-wrapper" *ngIf="product.metafield.key === 'patern_file'">
              <a [href]="product.metafield.reference.url" target="_blank" class="button button-outline button--secondary me-3">
                <span>{{ 'product-patroon-button-tekst' | fromDictionary }}</span>
              </a>
              <app-icon [anchor]="'icon-info'" (click)="tooltip.toggle()"></app-icon>
              <span
                #tooltip="matTooltip"
                class="product-pattern-wrapper__info"
                matTooltipClass="type--info"
                [matTooltip]="'product-patroon-tooltip-tekst' | fromDictionary"
                matTooltipPosition="below"
              ></span>
            </div>
          </ng-container>
        </footer>

        <ng-container *ngIf="listSpecifications(product) as specs">
          <hr class="my-4" *ngIf="specs.length" />
          <app-product-specifications *ngIf="specs.length" [specs]="specs"></app-product-specifications>
        </ng-container>

        <div class="mt-4-5" *ngIf="product?.descriptionHtml || '' | stripHtml">
          <h2 class="h5 mb-1">{{ 'product-omschrijving-titel' | fromDictionary }}</h2>
          <div class="markdown-content type-body-sm" [innerHTML]="product.descriptionHtml"></div>
        </div>
      </div>
    </main>
  </div>

  <ng-container *ngIf="recommendations$ | async as relatedProducts">
    <section class="related-products section-inset-y mt-2-5" *ngIf="relatedProducts.length">
      <h1>{{ 'product-gerelateerd-titel' | fromDictionary }}</h1>
      <ul class="row product-list">
        <li
          class="col-6 col-md-4"
          *ngFor="let item of relatedProducts | slice: 0 : 3; let i = index"
          [ngClass]="i > 1 ? 'd-none d-md-block' : ''"
        >
          <app-product-card [product]="item" [showSlider]="true" [sizes]="{ xs: 6, md: 2, lg: 1 }"></app-product-card>
        </li>
      </ul>
    </section>
  </ng-container>
  <app-json-ld *ngIf="schema" [json]="schema"></app-json-ld>
</article>

<!-- <app-json-ld [json]="breadcrumbScheme"></app-json-ld> -->
